import React, { useState, useMemo } from 'react';

export const CACDropdown = ({
  rowIndex,
  value,
  onChange,
  onKeyDown,
  onFocus,
  fieldIndex,
  field
}) => {
  const [pasteRowIndex, setPasteRowIndex] = useState(null);
  
  // Memoize display value to prevent unnecessary updates
  const displayValue = useMemo(() => {
    const option = field.options.find(opt => opt.value === value);
    return option ? option.label : value || '';
  }, [value, field.options]);

  const handleInputChange = (e) => {
    onChange({ target: { value: e.target.value } });
  };

  const handleBlur = (e) => {
    const inputText = e.target.value.toLowerCase();
    const matchedOption = field.options.find(option => 
      option.label.toLowerCase() === inputText
    );
    
    if (matchedOption) {
      onChange({ target: { value: matchedOption.value } });
    }
  };

  return (
    <div 
      className="flex relative certification-dropdown" 
      ref={(el) => {
        // Store the dropdown button element for positioning
        if (el && pasteRowIndex === rowIndex) {
          const rect = el.getBoundingClientRect();
          el.style.setProperty('--dropdown-top', `${rect.bottom + window.scrollY}px`);
          el.style.setProperty('--dropdown-left', `${rect.left + window.scrollX}px`);
        }
      }}
    >
      <input
          type="text"
          value={displayValue}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            // Handle Escape key to close dropdown
            if (e.key === 'Escape' && pasteRowIndex === rowIndex) {
              e.preventDefault();
              setPasteRowIndex(null);
              return;
            }
            
            // If dropdown is open and arrow key is pressed, close dropdown and allow navigation
            if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key) && pasteRowIndex === rowIndex) {
              setPasteRowIndex(null);
            }
            
            // Always pass navigation keys to parent handler
            if (['Tab', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
              onKeyDown(e, rowIndex, fieldIndex);
            }
          }}
          onBlur={handleBlur}
          onFocus={onFocus}
          className="block w-full px-2 py-1 text-sm border-0 outline-none focus:ring-0 focus:outline-none"
          name="cac_sticker"
          data-row={rowIndex}
          data-field="cac_sticker"
        />
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setPasteRowIndex(pasteRowIndex === rowIndex ? null : rowIndex);
          }}
          className="px-2 border-l border-gray-200 hover:bg-gray-50"
        >
          <svg className="h-4 w-4 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
        {pasteRowIndex === rowIndex && (
          <div 
            className="fixed z-50 bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto"
            style={{
              width: '200px',
              top: 'var(--dropdown-top)',
              left: 'var(--dropdown-left)',
              position: 'fixed'
            }}
          >
            <div className="py-1">
              {field.options.map(option => (
                <div
                  key={option.value}
                  className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    onChange({ target: { value: option.value } });
                    setPasteRowIndex(null);
                  }}
                >
                  {option.label}
                </div>
              ))}
            </div>
          </div>
        )}
    </div>
  );
};
